// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1__UH","cls2":"AuthorHeader-cls2__k4 AuthorHeader-cls1__UH"};